import * as React from "react";
import logo from "./../../images/cylontechnology.png";
import "../Header/Header.css";
import { useNavigate, Link } from "react-router-dom";

function Header() {
  const navbarToggler = document.querySelector(".navbar-toggler");
  const navbarCollapse = document.querySelector(".navbar-collapse");
  const navigate = useNavigate();

  if (navbarToggler && navbarCollapse.classList.contains("show")) {
    navbarToggler.click(); // Simulates a click to close the menu
  }
  return (
    <>
      <header id="web_header">
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            <div className="container-fluid">
              <a className="navbar-brand" href="/">
                <img src={logo} alt="logo" />
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#website-nav"
                aria-controls="website-nav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="website-nav">
                <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      onClick={() => {
                        navigate("/industries");
                      }}
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Industries
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/energy-utilities");
                          }}
                        >
                          Energy & Utilities
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/financial-services");
                          }}
                        >
                          Financial Services
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/healthcare");
                          }}
                        >
                          Healthcare
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/public-sector-services");
                          }}
                        >
                          Public Sector Services
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/insurance");
                          }}
                        >
                          Insurance
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/retail");
                          }}
                        >
                          Retail
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/manufacturing");
                          }}
                        >
                          Manufacturing
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/igmaing");
                          }}
                        >
                          iGaming
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      onClick={() => {
                        navigate("/offerings");
                      }}
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      offerings
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/analytics");
                          }}
                        >
                          Analytics
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/application-development");
                          }}
                        >
                          Application Development
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/it-managed-services");
                          }}
                        >
                          IT Managed Services
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/big-data");
                          }}
                        >
                          Big Data
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/devops");
                          }}
                        >
                          Devops
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/mobility-solutions");
                          }}
                        >
                          Mobility Solutions
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/testing");
                          }}
                        >
                          Testing Services
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/casino-engine");
                          }}
                        >
                          Casino Engine
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/fantasy-betting");
                          }}
                        >
                          Fantasy Betting
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      role="button"
                      data-bs-toggle="dropdown"
                      onClick={() => {
                        navigate("/our-story");
                      }}
                      aria-expanded="false"
                    >
                      About
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            navigate("/our-story");
                          }}
                        >
                          Our Story
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-item">
                    <a
                      className="nav-link"
                      onClick={() => {
                        navigate("/careers");
                      }}
                    >
                      Career
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      onClick={() => {
                        navigate("/connect");
                      }}
                    >
                      Connect
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
}

export default Header;
